import * as React from 'react';
import { useMediaQuery, styled, Paper, Avatar, Fab } from '@mui/material';

import { useSelector } from 'react-redux';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import { useHistory, useLocation } from 'react-router-dom';
import MobileDrawer from './MobileDrawer';
const validPermission = 'update:schoolProfile';
const certifiedPermission = 'create:availability';

const StyledBottomNavAction = styled(BottomNavigationAction)(({ theme }) => ({
    color: '#3d4459',
    '&:focus': {
        color: '#4632DA',
    },
}));

const BottomNavigationBar = props => {
    const profile = useSelector(state => state.profile.profile);
    const tokenStatus = useSelector(state => state.token.status);
    const { token } = useSelector(state => state.token);
    const isTabletAndAbove = useMediaQuery(theme => theme.breakpoints.up('md'));

    const [state, setState] = React.useState({
        schoolAdmin: false,
        fullVerification: false,
    });
    const [value, setValue] = React.useState('Home');
    const [open, setOpen] = React.useState(false);

    const history = useHistory();

    const location = useLocation();
    const pathnameSegments = location.pathname.split('/');

    // Check if the pathname has more than two segments
    const hasMoreThanOneSegments = pathnameSegments.filter(
        item => item !== ''
    ).length;
    const handleChange = (event, newValue) => {
        setValue(newValue);
        history.push('/' + newValue);
    };
    React.useEffect(() => {
        if (tokenStatus === 'succeeded' && token.Count === 1) {
            let schoolAdminTemp = false;
            let certifiedPermissionTemp = false;

            if (token.permissions.includes(validPermission)) {
                schoolAdminTemp = true;
            }

            if (token.permissions.includes(certifiedPermission)) {
                certifiedPermissionTemp = true;
            }

            setState({
                ...state,
                schoolAdmin: schoolAdminTemp,
                fullVerification: certifiedPermissionTemp,
            });
        }
    }, [tokenStatus, token.Count, token.permissions]);

    // React.useEffect(() => {
    //     let val = value;
    //     location.pathname.includes('/history') && value !== 'history'
    //         ? setValue('history')
    //         : location.pathname.includes('/profile/userInfo') &&
    //           value !== 'profile/userInfo'
    //         ? setValue('profile/userInfo')
    //         : location.pathname.includes('/notifications') &&
    //           value !== 'notifications'
    //         ? setValue('notifications')
    //         : location.pathname.includes('/Home') && value !== 'Home'
    //         ? setValue('Home')
    //         : setValue(val);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [location.pathname]);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    return (
        <div
            style={{ display: hasMoreThanOneSegments === 0 ? 'none' : 'block' }}
        >
            {!isTabletAndAbove && profile.Data.Count > 0 ? (
                <Paper
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 1200,
                        background: '#9E9E9E',
                        width: '100%',
                        // display: hasMoreThanOneSegments > 1 ? 'none' : 'block',
                    }}
                    elevation={3}
                >
                    <Fab
                        color="primary"
                        aria-label="profile"
                        sx={{
                            position: 'absolute',
                            top: '-30%',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            border: '5px solid #06D9FA',
                            height: '65px',
                            width: '65px',
                            cursor: 'pointer',
                            pointerEvents: 'auto',
                            zIndex: 50,
                        }}
                        onClick={() => {
                            history.push('/profile/userInfo');
                        }}
                    >
                        <Avatar
                            src={
                                profile.Data.Count > 0
                                    ? profile.Data.Items[0].profileImage
                                    : ''
                            }
                            sx={{ height: '60px', width: '60px' }}
                            alt="airTeachr Profile"
                        />
                    </Fab>
                    <BottomNavigation
                        sx={{
                            width: '100%',
                        }}
                        value={value}
                        onChange={handleChange}
                    >
                        <StyledBottomNavAction
                            value="Home"
                            sx={{ color: '#3d4459 !important' }}
                            icon={<HomeRoundedIcon />}
                        />
                        <StyledBottomNavAction
                            sx={{ color: '#3d4459 !important' }}
                            value="history"
                            icon={<PendingActionsRoundedIcon />}
                        />
                        <StyledBottomNavAction
                            disabled
                            value="profile/userInfo"
                            icon={''}
                        />
                        <StyledBottomNavAction
                            sx={{ color: '#3d4459 !important' }}
                            value="notifications"
                            icon={<NotificationsRoundedIcon />}
                        />
                        <StyledBottomNavAction
                            sx={{ color: '#3d4459 !important' }}
                            onClick={handleDrawerOpen}
                            value={value}
                            icon={<MenuRoundedIcon />}
                        />
                    </BottomNavigation>
                </Paper>
            ) : null}
            <MobileDrawer
                open={open}
                toggleClose={handleDrawerClose}
                toggleOpen={handleDrawerOpen}
            />
        </div>
    );
};
export default BottomNavigationBar;
